export const CHART_POINTS_PER_SERIES = 1000;
export const DEFAULT_RAW_DATAPOINTS_LIMIT = 500;
